// https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser/9851769

export const browserReliableDetection = () => {
  let browser = null;

  if ((navigator.userAgent.indexOf('Opera') || navigator.userAgent.indexOf('OPR')) !== -1) {
    browser = 'Opera';
  } else if (navigator.userAgent.indexOf('Chrome') !== -1) {
    browser = 'Chrome';
  } else if (navigator.userAgent.indexOf('Safari') !== -1) {
    browser = 'Safari';
  } else if (navigator.userAgent.indexOf('Firefox') !== -1) {
    browser = 'Firefox';
  } else if ((navigator.userAgent.indexOf('MSIE') !== -1) || (!!document.documentMode === true)) {
    browser = 'IE';
  } else {
    browser = 'unknown';
  }

  return browser;
};
